import { render, staticRenderFns } from "./barChartStack.vue?vue&type=template&id=40f56770"
import script from "./barChartStack.vue?vue&type=script&lang=js"
export * from "./barChartStack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports